import {
  queryUserAccountList,
  registerStaffAccount,
  updateStaffAccount,
  resetPassword,
  deleteUserAccount,
  bindUserRoles
} from "@/graphql/userManager.gql";
import { filterNodeData } from "@root/lib/utils";
export default {
  namespaced: true,
  state: {
    dataList: []
  },
  getters: {},
  actions: {
    async getDataList({ rootState, commit }, data) {
      let {
        data: {
          res: {
            dataList,
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryUserAccountList,
        variables: data
      });
      commit("setDataList", dataList);
      return { total };
    },
    async addUser({ rootState, commit }, data) {
      await rootState.gql.mutate({
        mutation: registerStaffAccount,
        variables: data
      });
    },
    async updateStaffAccount({ rootState, commit }, data) {
      await rootState.gql.mutate({
        mutation: updateStaffAccount,
        variables: data
      });
    },
    async bindUserRoles({ rootState, commit }, data) {
      await rootState.gql.mutate({
        mutation: bindUserRoles,
        variables: data
      });
    },
    async reSetOpUserAccountPassword({ commit, state, rootState }: any, data) {
      await rootState.gql.mutate({
        mutation: resetPassword,
        variables: data
      });
    },
    async deleteUserAccount({ commit, state, rootState }: any, data) {
      await rootState.gql.mutate({
        mutation: deleteUserAccount,
        variables: data
      });
    }
  },
  mutations: {
    setDataList(state, data) {
      state.dataList = filterNodeData(data);
    }
  }
};
